import React from 'react'

interface RecipeClusterNodeProps {
  label: string
  position: [number, number]
  dimensions: [number, number]
}

const RecipeClusterNode: React.FunctionComponent<RecipeClusterNodeProps> = ({ label, position, dimensions }) => {
  const [x, y] = position
  const [width, height] = dimensions

  return (
    <g className={label} transform={label === 'main' ? '' : `translate(${x - width / 2}, ${y - height / 2})`}>
      <rect
        width={width}
        height={height}
        fill="none"
        stroke="rgba(0, 0, 0, 0.5)"
        rx={6}
        strokeWidth={2}
        strokeDasharray="2px"
      />
      <g transform="translate(8, 16)">
        <text textAnchor="start" fontSize={12} className="flow-cluster-label">
          <tspan>{label}</tspan>
        </text>
      </g>
      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');

        .flow-cluster-label {
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          fill: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </g>
  )
}

export default RecipeClusterNode
